module.exports = __webpack_public_path__ + "static/img/xjgdjt.d807d6f8.png";